import {defaultFilter, defaultFilterCategory} from "@/servicios/videos/state";

/**
 * Setear categorias videos.
 *
 * @param categories
 */
export function setVideoCategories(state, categories) {
    state.video_categories = categories
}

/**
 * Setear videos.
 * @param videos
 */
export function setVideos(state, videos) {
    state.videos = videos
}

/**
 * Limpiar filtro
 */
export function clearFilter(state) {
    state.filter = defaultFilter()
}

/**
 * cambia el estado para mostrar modal.
 *
 * @param show
 */
export function changeStateModalForm(state, show) {
    state.showModalForm = show;
}

/**
 * Setear información del payload de videos.
 *
 * @param show
 */
export function setPayloadForm(state, data) {
    const payloadForm =  structuredClone(data)
    state.payloadForm = payloadForm;
}

/**
 * Actualizar la cantidad de items a mostrar en la tabla.
 *
 */
export function updatePerPage(state, per_page) {
    state.filter.per_page = per_page
}

/**
 * Setear videos para empresas
 * @param company_videos
 */
export function setVideosCompany(state, company_videos) {
    state.company_videos = company_videos
}

/**
 * Setear categorias de videos para empresas
 * @param categoryId, videos
 */
export function setVideosByCategory(state, { categoryId, videos }) {
    state.videosByCategory = {
        ...state.videosByCategory,
        [categoryId]: videos
    };
}

/**
 * Cambia el estado para mostrar modal para crear categorias.
 *
 * @param show
 */
export function changeStateModalFormCategory(state, show) {
    state.showModalFormCategory = show;
}

/**
 * Setear información del payload de categorias.
 *
 * @param show
 */
export function setPayloadFormCategory(state, data) {
    const payloadFormCategory =  structuredClone(data)
    state.payloadFormCategory = payloadFormCategory;
}

/**
 * Setear categorias y subcategorias de videos.
 *
 * @param categories_list
 */
export function setVidCategoriesSubcategories(state, categories_list) {
    state.categories_list = categories_list
}

/**
 * Limpiar filtro
 */
export function clearFilterCategory(state) {
    state.filterCategories = defaultFilterCategory();
}
